
/*
  This component will display selectbox in configurator
 */

import React, {useEffect} from 'react'
import store from "../../store/store"

const Select = (props) => {

    const handleChange = (e) => {
        store.dispatch({type: 'SET_ERRORS', value: false});
        props.handleAttribute(e.target.value);
        // call onChange passed from props to clear exception messages
        props.onChange();
    }


    const getOptionsForSelect = (attributes) => {
        const labelValue = [];

        // do we need to render -- at the start ?
        if (props.hasEmptyField) {
            labelValue.push({key: '', value: '---'});
        }
        const keys = attributes.values.split(",");
        const values = attributes.labels.split(",");

        if (props.patternSideKey){
            for (let i = 0; i < keys.length; i++) {
                labelValue.push({key: keys[i], value: values[i]});
            }
            return labelValue.map((label, index) => <option disabled={isDisabled(label.key) || props.disabled} value={label.key}
                                                            key={label.key}>{label.value} </option>)
        } else {
            for (let i = 0; i < keys.length; i++) {
                labelValue.push({key: keys[i], value: ' - ' + values[i]});
            }
            return labelValue.map((label, index) => <option disabled={isDisabled(label.key) || props.disabled} value={label.key}
                                                            key={label.key + "-" + isDisabled(label.key)}> {label.key} {label.value} </option>)
        }
    }

    const isDisabled = (value) =>{
        if( !props.disabledSelections || props.ignoreDisabled){
            return false;
        }
        const matchingSelection = props.disabledSelections.find(obj => obj == value);
        return matchingSelection
    }

    // Deselects if the option is selected AND disabled
    useEffect(() => {
        if(isDisabled(props.currentValue)){
            props.handleAttribute("");
        }
    })
    
    return (
            <select name='product-selector' id='product-selector' className={props.errorField ? 'error':''} defaultValue={props.currentValue} value={props.value} disabled={props.disabled || props.matchingSide || false } onChange={(e) => handleChange(e)} onClick={(e) => props.onClick(e)}>
                {getOptionsForSelect(props.attributes)}
            </select>
    )
    
}
export default Select;